module.exports = __webpack_public_path__ + "img/addicon.4292c602.svg";